<template>
  <div
    class="flex justify-between items-center text-cerise-red-600 gap-2 container py-3 px-5"
  >
    <div
      class="flex gap-1.5 md:gap-3"
      :class="
        !profileStore.isVip
          ? 'flex-col items-start md:items-end md:flex-row'
          : 'items-center'
      "
    >
      <nuxt-link to="/">
        <div v-if="!profileStore.isVip">
          <nuxt-img
            src="images/PNTLOVER.png"
            alt="logo"
            class="w-[200px] md:w-[250px] lg:w-[300px]"
          />
        </div>

        <nuxt-img
          v-else
          src="images/logo.svg"
          alt="logo"
          class="w-[134px] h-[37px] lg:w-[181px] lg:h-[50px]"
        />
      </nuxt-link>
      <span class="font-bold lg:leading-5 lg:text-[22px] mb-1"
        >Area Clienti</span
      >
    </div>
    <div class="hidden lg:flex gap-7 items-center">
      <nuxt-link
        to="https://www.prenatal.com"
        target="_new"
        class="flex gap-2 items-center"
      >
        <nuxt-img src="images/badges/shopping-cart.svg" class="w-5" />
        <span class="font-bold">Store online</span>
      </nuxt-link>

      <nuxt-link
        v-if="!isLoggedIn"
        to="/login"
        class="tracking-wide rounded-md"
        @click="signIn('sso')"
      >
        <CorePrimaryButton> ACCEDI </CorePrimaryButton>
      </nuxt-link>
      <div v-else class="flex gap-4">
        <nuxt-link to="/profile">
          <CoreOutlineButton> Bacheca </CoreOutlineButton>
        </nuxt-link>

        <CoreOutlineButton
          @click="signOut({ callbackUrl: '/' })"
          class="px-4 py-2 bg-white text-cerise-red-600 border border-cerise-red-600 rounded-3xl"
        >
          Logout
        </CoreOutlineButton>
      </div>
    </div>
    <div class="lg:hidden block" v-if="showMobileMenuOnRoutes">
      <div
        class="bg-cerise-red-600 w-12 h-12 rounded-full items-center flex justify-center"
      >
        <nuxt-img
          @click="$emit('menu', true)"
          src="images/hamburger.svg"
          alt="Menu"
          format="webp"
          class="bg-transparent cursor-pointer w-1/2"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useProfile } from "~/store/profile";

const profileStore = useProfile();
await profileStore.getProfile();

const { status, signIn, signOut } = useAuth();
const isLoggedIn = computed(() => status.value === "authenticated");

const route = useRoute();
const hiddenRoutes = ["/assistant", "/assistant/success"];

const showMobileMenuOnRoutes = computed(() =>
  !hiddenRoutes.includes(route?.path)
);
</script>
